import { abortReason, raceWithAbort, throwIfAborted } from './abortSignal';

/** Abort the underlying operation at its deadline, before releasing its caller. */
export async function withAbortableDeadline<T>(
  operation: (signal: AbortSignal) => Promise<T>,
  timeoutMs: number,
  label: string,
  callerSignal?: AbortSignal,
): Promise<T> {
  throwIfAborted(callerSignal);
  const controller = new AbortController();
  const forwardAbort = () => controller.abort(abortReason(callerSignal));
  callerSignal?.addEventListener('abort', forwardAbort, { once: true });
  const timer = setTimeout(() => controller.abort(new Error(`${label} timed out after ${timeoutMs}ms`)), timeoutMs);
  try {
    return await raceWithAbort(Promise.resolve().then(() => {
      throwIfAborted(controller.signal);
      return operation(controller.signal);
    }), controller.signal);
  } finally {
    clearTimeout(timer);
    callerSignal?.removeEventListener('abort', forwardAbort);
  }
}
